module.exports = __webpack_public_path__ + "static/media/green_nebula_skybox_BK.43081eb0.png";